import { PayloadAction } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';

import { getDisplaySurveyBL, GetDisplaySurveyResponse } from 'businessLogic/Mailchimp/Messaging';
import { saleSelectors } from 'store/sale/selectors';
import { sliceFactory, thunkActionFactory } from 'store/utils';
import { PostInvoiceSurvey, SurveyOpen } from 'types/PostInvoiceSurvey';

const initialState: PostInvoiceSurvey = {
  surveyOpen: SurveyOpen.None,
  loading: true,
  surveys: null,
};

const { actions, reducer } = sliceFactory({
  name: 'postInvoiceSurvey',
  initialState,
  reducers: {
    setSurveyOpen: (state, action: PayloadAction<PostInvoiceSurvey>) => {
      const { surveyOpen } = action.payload;
      state.surveyOpen = surveyOpen;
    },
    setLoading: (state, action: PayloadAction<PostInvoiceSurvey>) => {
      const { loading } = action.payload;
      state.loading = loading;
    },
    setSurveys: (state, action: PayloadAction<PostInvoiceSurvey>) => {
      const { surveys } = action.payload;
      state.surveys = surveys;
    },
  },
});

export const fetchDisplaySurveySettings = thunkActionFactory(async ({ state, dispatch }) => {
  const {
    config: { ssrtid, portal },
    insight: { token, domainId },
    auth: { authToken, realmId, entityId, ticket, isUserSignedIn, syncToken },
    sale,
  } = state;

  const customerId = saleSelectors.customerLocalNameIdSelector(sale) ?? '';
  if (!customerId || !realmId) return;
  const resp = (await getDisplaySurveyBL({
    ssrtid,
    portal,
    acsToken: token,
    realmId,
    authToken,
    domainId,
    entityId,
    ticket,
    isUserSignedIn,
    syncToken,
    data: {
      customerId,
    },
  })) as AxiosResponse<GetDisplaySurveyResponse>;

  dispatch(postInvoiceSurveyActions.setSurveys(resp.data));

  return resp;
});

export const postInvoiceSurveyReducer = reducer;
export const postInvoiceSurveyActions = actions;
